import useSWRImmutable from 'swr/immutable';
import CruiseService from '@/services/TourServices/CruiseService';

const useCruiseTourAmenities = () => useSWRImmutable(
    'cruise-tour-amenities',
    CruiseService.getAmenities,
);

export default useCruiseTourAmenities;
